
var ModalController = function ($, ko, _, core, KOHelpers, helpers) {

    var self = this;

    self.Visible = ko.observable();
    self.Header  = ko.observable();
    self.Body    = ko.observable();
    self.Buttons = ko.observableArray([{ id:'OK', text: 'OK', css: 'btn-default'}]);

    var resolve, reject, consumeResolve = function (context) { resolve && resolve(context); resolve = null  }
    
    self.show = function(){

        
        var promise = new core.Promise(function(_resolve,_reject){
            
            resolve = _resolve;
            reject  = _reject;
            
        })

        self.Visible(true);

        console.error('++ showing modal', promise, self);

        return promise;
    }

    self.click = function (context) {

        console.log('modal click', context);          

        consumeResolve(context);        

        self.Visible(false);

    }

    self.Visible.subscribe(function (visible) {

       if(!visible && resolve){

           console.log('modal closed by other means');          

           consumeResolve({ id: 'unknown' });        
       }

    });


    
    console.log('ModalController', self);

    var template = require('ModalControllerView.html')
     ,  $element = $(template);   

    $element.appendTo('body');
    
    KOHelpers.safeApplyBindings(self, "modalControllerView");
}

module.exports = ModalController;